import { render, staticRenderFns } from "./PromoCodesComponent.vue?vue&type=template&id=3b47cc6e"
import script from "./PromoCodesComponent.vue?vue&type=script&lang=js"
export * from "./PromoCodesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b47cc6e')) {
      api.createRecord('3b47cc6e', component.options)
    } else {
      api.reload('3b47cc6e', component.options)
    }
    module.hot.accept("./PromoCodesComponent.vue?vue&type=template&id=3b47cc6e", function () {
      api.rerender('3b47cc6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/promocodes-component/PromoCodesComponent.vue"
export default component.exports